import { ExternalLinks } from '@type/component-data-types'
import * as React from 'react'

const ExternalLink = (props: ExternalLinks): React.JSX.Element => {
  const defaultCssClass = 'externalLink'
  const baseCssClass = props.noCssClass ? '' : defaultCssClass
  const mergedClassName = props.className
    ? `${baseCssClass} ${props.className}`
    : baseCssClass

  return (
    <a
      href={props.to}
      className={mergedClassName}
      target="_blank"
      id={props.id}
    >
      {props.children}
    </a>
  )
}

export default ExternalLink
